






import { Component, Vue } from "vue-property-decorator";
import { msalService } from "@/auth/msalService";

@Component
export default class MsalLoggedOnComponent extends Vue {
  private readonly NOT_LOGGED_ON_PERSON_NAME: string = "niet ingelogd";

  private displayValue: string = this.NOT_LOGGED_ON_PERSON_NAME;

  public mounted() {
    // The MSAL account only changes after a redirect, which reloads the page,
    // so assigning on mount is enough - there is no event to subscribe to.
    this.assignValues();
  }

  assignValues() {
    const account = msalService.getAccount();

    if (account) {
      this.displayValue = account.name || account.username;

      if (
        account.name !== undefined &&
        account.name !== null &&
        account.name !== "" &&
        account.username !== account.name
      ) {
        this.displayValue += " (" + account.username + ")";
      }
    } else {
      this.displayValue = this.NOT_LOGGED_ON_PERSON_NAME;
    }
  }
}
